var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc18YearsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5432 8.46452C8.50251 12.9833 4.81865 23.8114 9.22081 32.6189C13.623 41.4263 24.4948 44.9792 33.5355 40.4604C41.0295 36.7148 44.85 28.6218 43.4198 20.9486C43.2324 19.9432 43.8956 18.9762 44.901 18.7888C45.9064 18.6014 46.8734 19.2646 47.0608 20.27C48.7929 29.5632 44.1673 39.287 35.1914 43.7734C24.3775 49.1784 11.2525 44.9678 5.90788 34.2747C0.563233 23.5817 5.07342 10.5567 15.8874 5.15159C24.9056 0.644059 35.517 2.82229 41.9009 9.86468C42.5878 10.6224 42.5304 11.7935 41.7726 12.4804C41.0149 13.1673 39.8438 13.1099 39.1569 12.3522C33.8864 6.53803 25.0728 4.70109 17.5432 8.46452Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.342 33.6429H12.9218V19.0714H10V16.5714C12.0228 16.6429 13.2964 15.8571 14.0456 14H17.342V33.6429ZM21.4625 28.0714C21.4625 26.1429 21.9121 24.7857 23.6352 23.5714C22.2117 22.2143 21.6873 21.0714 21.6873 19.2857C21.6873 16.2143 23.785 14 27.2313 14C30.6775 14 32.7752 16.2143 32.7752 19.2857C32.7752 21.0714 32.2508 22.2143 30.8274 23.5714C32.5505 24.7857 33 26.1429 33 28.0714C33 31.5714 31.8013 34 27.2313 34C22.6612 34 21.4625 31.5714 21.4625 28.0714ZM27.2313 25.2857C26.1824 25.2857 25.9577 26 25.9577 27.8571C25.9577 29.7143 26.1824 30.3571 27.2313 30.3571C28.2801 30.3571 28.5049 29.7143 28.5049 27.8571C28.5049 26 28.2801 25.2857 27.2313 25.2857ZM27.2313 17.5714C26.2573 17.5714 26.0326 18 26.0326 19.8571C26.0326 21.7143 26.2573 22.1429 27.2313 22.1429C28.2052 22.1429 28.43 21.7143 28.43 19.8571C28.43 18 28.2052 17.5714 27.2313 17.5714Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 24C34 23.3627 34.5084 22.8462 35.1355 22.8462H36.8952V21.1613C36.8952 20.5199 37.4069 20 38.0381 20C38.6693 20 39.181 20.5199 39.181 21.1613V22.8462H40.8645C41.4916 22.8462 42 23.3627 42 24C42 24.6373 41.4916 25.1538 40.8645 25.1538H39.181V26.8387C39.181 27.4801 38.6693 28 38.0381 28C37.4069 28 36.8952 27.4801 36.8952 26.8387V25.1538H35.1355C34.5084 25.1538 34 24.6373 34 24Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc18YearsActive);
export default __webpack_public_path__ + "static/media/ic_18years_active.87d7457a510c691e3a8bb3e701c426f3.svg";
export { ForwardRef as ReactComponent };